export function getOriginalGraphEdges(edges = []) {
  const seenPeople = new Set();

  return edges.filter((edge) => {
    if (!edge?.person1 || !edge?.person2) return false;

    const introducesPerson = !seenPeople.has(edge.person1) || !seenPeople.has(edge.person2);
    if (!introducesPerson) return false;

    seenPeople.add(edge.person1);
    seenPeople.add(edge.person2);
    return true;
  });
}

export function getNonOriginalGraphEdges(edges = []) {
  const originalEdgeIds = new Set(getOriginalGraphEdges(edges).map((edge) => edge._id));
  return edges.filter((edge) => edge?._id && !originalEdgeIds.has(edge._id));
}
